import MapUtils from '@vendor/js/map-utils';
import * as _ from 'underscore';
import { Api } from '@vendor/js/api';
import { BaseCustomFeatures } from '@vendor/libs/maps/features/base';
import { ApiaryFeatures } from '@vendor/libs/maps/features/apiaries';
import { AssociationBoundaryFeatures } from '@vendor/libs/maps/features/association-boundaries';
import { OverlayFeatureAddon } from '@vendor/libs/maps/features/addons';
import { InfectionFeatures } from '@vendor/libs/maps/features/infections';
import { UnaffiliatedApiaryFeatures } from '@vendor/libs/maps/features/unaffiliated-apiaries';
export class AsyncFeatures extends BaseCustomFeatures {
    constructor(options = {}) {
        super('async-features', { visibilityListed: false });
        this.availableFeatures = null;
        this.getAvailableFeaturesClasses = () => {
            if (this.availableFeatures != null) {
                return this.availableFeatures;
            }
            if (!this.customMap) {
                return this.availableFeatures;
            }
            let apiaries = new ApiaryFeatures({ visibilityName: 'apiaries' });
            apiaries.name = 'async-apiaries';
            let unaffiliatedApiaries = new UnaffiliatedApiaryFeatures({
                visibilityName: 'unaffiliated-apiaries',
            });
            unaffiliatedApiaries.name = 'async-unaffiliated-apiaries';
            let infections = new InfectionFeatures({ visibilityName: 'infections' });
            infections.name = 'async-infections';
            let associations = new AssociationBoundaryFeatures({
                visibilityName: 'association-boundaries',
            });
            associations.name = 'async-association-boundaries';
            this.customMap.addFeatures('async-association-boundaries', associations);
            this.customMap.addFeatures('async-apiaries', apiaries);
            this.customMap.addFeatures('async-unaffiliated-apiaries', unaffiliatedApiaries);
            this.customMap.addFeatures('async-infections', infections);
            this.availableFeatures = {
                associations,
                apiaries,
                unaffiliatedApiaries,
                infections,
            };
            return this.availableFeatures;
        };
        const that = this;
        const onViewChange = async () => {
            if (!this.customMap) {
                return;
            }
            const availableFeatures = this.getAvailableFeaturesClasses();
            const extent = this.customMap.ol
                .getView()
                .calculateExtent(this.customMap.ol.getSize());
            const topLeft = MapUtils.toLonLat([extent[0], extent[1]]);
            const bottomRight = MapUtils.toLonLat([extent[2], extent[3]]);
            that.customMap?.setLoading(true);
            try {
                let params = [];
                if (options.muteNotMineApiaries) {
                    params.push('muteNotMineApiaries=true');
                }
                if (options.muteApiaries) {
                    params.push('muteApiaries=true');
                }
                if (options.muteInfections) {
                    params.push('muteInfections=true');
                }
                if (options.muteUnaffiliatedApiaries) {
                    params.push('muteUnaffiliatedApiaries=true');
                }
                const response = await Api.get([
                    '/map/features',
                    `?bbox=${topLeft[0]},${topLeft[1]},${bottomRight[0]},${bottomRight[1]}`,
                    `${options.except?.map((e) => `&except[]=${e.class},${e.id}`) ?? ''}`,
                    `&${params.join('&')}`,
                ].join(''));
                this.data = response.data;
                for (const features in availableFeatures) {
                    if (typeof response.data[features] != 'undefined' &&
                        Array.isArray(response.data[features])) {
                        availableFeatures[features].clear();
                        for (const object of response.data[features]) {
                            if (availableFeatures[features].features.find((f) => f.getId() == object.id)) {
                                continue;
                            }
                            availableFeatures[features].fromGeoJSON(object.geojson);
                        }
                    }
                }
            }
            catch (err) {
                console.error('Could not load map features: ' + err);
            }
            finally {
                that.customMap?.setLoading(false);
            }
        };
        this.on('setup', function () {
            if (that.customMap) {
                that.customMap.ol
                    .getView()
                    .on('change:center', _.throttle(onViewChange, 2000));
                const availableFeatures = that.getAvailableFeaturesClasses();
                if (availableFeatures &&
                    typeof availableFeatures.apiaries != 'undefined') {
                    availableFeatures.apiaries.addAddon('overlay', new OverlayFeatureAddon({
                        render: ({ feature }) => {
                            const apiary = that.data?.apiaries &&
                                that.data.apiaries.find((a) => a.id === feature.getId());
                            if (!apiary) {
                                return null;
                            }
                            return ApiaryFeatures.getOverlayHtml(apiary);
                        },
                    }));
                }
                if (availableFeatures &&
                    typeof availableFeatures.unaffiliatedApiaries != 'undefined') {
                    availableFeatures.unaffiliatedApiaries.addAddon('overlay', new OverlayFeatureAddon({
                        render: ({ feature }) => {
                            const unaffiliatedApiary = that.data?.unaffiliatedApiaries &&
                                that.data.unaffiliatedApiaries.find((a) => a.id === feature.getId());
                            if (!unaffiliatedApiary) {
                                return null;
                            }
                            return UnaffiliatedApiaryFeatures.getOverlayHtml(unaffiliatedApiary);
                        },
                    }));
                }
            }
            onViewChange();
        });
    }
}
